import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from './dashboard.service';
import { Header } from '@aptsi-types';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
   // Summary data
  totalIdentities: number = 0;
  totalLedgerRecords: number = 0;
  totalContracts: number = 0;

  // Analytics and other data
  transactionsByChaincode: any[] = [];
  recordsByChaincode: any[] = [];
  identitiesByRole: any[] = [];
  chaincodeDetails: any[] = [];

  // Loading state
  isLoading = true;
  hasError = false;

  // Table headers for chaincode details
  headers: Header[] = [
    { name: 'Chaincode', property: 'chaincode', showInDropdown: true },
    { name: 'Version', property: 'version', showInDropdown: true },
    { name: 'Channel', property: 'channel', showInDropdown: true },
    { name: 'Status', property: 'status', showInDropdown: true }
  ];

  // Chart data (bar chart for transactions by chaincode)
  chartData: any = {};
  chartOptions: any = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        enabled: true,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Number of Transactions',
        },
      },
      x: {
        title: {
          display: true,
          text: 'Chaincode',
        },
      },
    },
  };

  constructor(private dashboardService: DashboardService) {}

  ngOnInit(): void {
    this.loadDashboardData();
  }

  private loadDashboardData(): void {
    this.isLoading = true;
    this.hasError = false;

    this.dashboardService
      .getSbcDashboard()
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (response) => {
          // Assuming response structure matches the provided JSON
          this.totalIdentities = response.summary?.totalIdentities ?? 0;
          this.totalLedgerRecords = response.summary?.totalLedgerRecords ?? 0;
          this.totalContracts = response.summary?.totalContracts ?? 0;

          this.transactionsByChaincode = response.analytics?.transactionsByChaincode ?? [];
          this.recordsByChaincode = response.analytics?.recordsByChaincode ?? [];
          this.identitiesByRole = response.identities?.byRole ?? [];
          this.chaincodeDetails = response.chaincodes?.details ?? [];

          this.prepareChartData();
        },
        error: (err) => {
          this.hasError = true;
          console.error('Error loading dashboard data:', err);
        }
      });
  }

  private prepareChartData(): void {
    // Handle empty transactions gracefully
    if (!this.transactionsByChaincode.length) {
      this.chartData = { labels: [], datasets: [] };
      return;
    }

    this.chartData = {
      labels: this.transactionsByChaincode.map((item) => item.chaincode),
      datasets: [
        {
          label: 'Transactions',
          data: this.transactionsByChaincode.map((item) => item.transactions),
          backgroundColor: [
            'rgba(54, 162, 235, 0.6)',
            'rgba(255, 206, 86, 0.6)',
            'rgba(75, 192, 192, 0.6)',
            'rgba(153, 102, 255, 0.6)',
            'rgba(255, 159, 64, 0.6)'
          ],
          borderColor: [
            'rgba(54, 162, 235, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(75, 192, 192, 1)',
            'rgba(153, 102, 255, 1)',
            'rgba(255, 159, 64, 1)'
          ],
          borderWidth: 1,
        },
      ],
    };
  }
}